import type { FaireProductEntity } from "../../entity_types/product";

export const p_8b396yfsfp: FaireProductEntity = {
  token: "p_8b396yfsfp",
  type: "product",
  name: "DROP SHOULDER SHIRRED SLEEVES MIDI DRESS - VGD42995",
  brandToken: "b_5vokhafgu0",
  brandName: "Final Touch",
  imageUrl:
    "https://cdn.faire.com/fastly/94eb149007cd376b66b27f1b6140d9cbc8a4b7b13763f3cc683d9609f5d22de4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3de24265c6d18be3c91fbe84cb7868fd83074ce49f559f699d2075b35bebb4e0.jpeg",
    "https://cdn.faire.com/fastly/0d5645063600083208399bfe2ed30ae7bb93d9d0b0bd6450b4899414b9cd7714.jpeg",
    "https://cdn.faire.com/fastly/d2ce2694c4a75beba2e3496144f79b09c59bd37016deaed2d057f6f52c48f4a1.jpeg",
    "https://cdn.faire.com/fastly/24d6ec49aacf40274240c7ff0db8d340b7cac42f6ddd665f36443c9646cfc28d.jpeg",
    "https://cdn.faire.com/fastly/17b78dc1b7ed313a90fdf32ab695d77a822e5bf3d0262737b989d4e51060fe45.jpeg",
  ],
  priceDollars: 110,
  description:
    "DROP SHOULDER  WITH SHIRRED SLEEVES AND 3-LINE WAIST BUTTON DOWN MIDI DRESS. \n100% RAYON \n",
  tags: [],
  msrpDollars: 220,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:05.994Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
